<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hZPPzj/tc-custom/9781480464957.jpg?1734040329852" alt="This image is the cover for the book Tek Kill, The TekWar Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tek Kill, The TekWar Series
      </h1>
      <p class="bookDescription body article font2">
        <b>In order to expose a sinister, far-reaching criminal conspiracy, detective Jake Cardigan , the twenty-second century’s most able private detective, must prove that an open-and-shut murder case is anything but</b><br/><br/> Once again the inimitable William Shatner, <i>Star Trek</i>’s original Captain Kirk and a true star of science fiction adventure, brings the future vibrantly alive in the eighth nonstop, action-packed futuristic caper featuring private investigator Jake Cardigan, sworn enemy of the all-powerful TekLords.<br/>  <br/> Walt Bascom, head of the Cosmos Detective Agency, is in serious trouble. Video surveillance in the home of superrich businessman Dwight Grossman clearly shows Bascom murdering the entrepreneur in cold blood. Bascom swears he didn’t do it, and he’s relying on his agency’s best investigator, Jake Cardigan, to prove it somehow.<br/>  <br/> Jake and his partner, Sid Gomez, have their work cut out for them. The only “evidence” on their side is the testimony of the dead man’s sister, Susan, who claims she’s had telepathic visions of her brother’s true death. But Susan is an admitted devotee of the powerful, reality-altering electronic drug Tek. Whoever wanted her brother dead—and Bascom accused—went to great lengths to set up the scheme, and those responsible are not going to sit idly by while a pair of snooping private eyes and a burned-out Tek fiend start digging for answers. To keep the killers’ dark and very dirty secrets hidden, one corpse may not be enough.<br/><br/><i>This ebook features an illustrated biography of William Shatner including rare images and never-before-seen documents from the author’s personal collection.</i><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William Shatner
      </h2>
      
      <p class="authorDescription body article">William Shatner (b. 1931) is a Canadian actor, author, and film director, known for his irreverent charm and his star turn as Captain Kirk in the original <i>Star Trek </i>television series, as well as many other roles. Born and raised in Montreal, Quebec, Shatner was cast in <i>Star Trek</i> as the courageous, unpredictable Captain James T. Kirk in 1966. The show became a cult hit in syndication, leading to a number of spin-offs and movies. Shatner starred in seven <i>Star Trek</i> films beginning with <i>Star Trek: The Motion Picture</i> in 1979. He later played leading roles on the television series <i>T.J. Hooker</i> (1982&ndash;86) and <i>Boston Legal </i>(2004&ndash;08). Shatner has also published a number of novels, most notably <i>TekWar</i> (1989), a science-fiction thriller that inspired eight sequels as well as video games and a television series. When he isn&rsquo;t working, Shatner and his wife, Elizabeth, divide their time between Southern California and Kentucky.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4f7cd388